<template>
  <div>
    <CRow>
      <!-- Botón importar Excel -->
      <CRow class="mb-2 px-3">
        <CCol sm="12">
          <input ref="inputExcel" type="file" accept=".xlsx,.xls" style="display:none"
            @change="mtd_onFileSelected" />
          <CButton color="success" size="sm" @click="$refs.inputExcel.click()"
            :disabled="import_excel.loading">
            <i class="fas fa-file-excel"></i>
            {{ import_excel.loading ? 'Importando...' : 'Importar Excel' }}
          </CButton>
        </CCol>
      </CRow>

      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Materiales"
          icon="fas fa-box-open"
          btn_name="Material"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="true"
        />
      </CCol>
    </CRow>

    <!-- ===================== MODAL STORE / UPDATE ===================== -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Digite nombre del material"
            v-model="material.name"
          />
        </CCol>

        <CCol sm="6" v-if="modal.action == 'store'">
          <cSelectForm
            label="Unidad"
            placeholder="Seleccione unidad"
            :options="data_units"
            :value.sync="material.unit_id"
          />
        </CCol>

        <!-- Cantidad inicial solo al crear -->
        <CCol sm="6" v-if="modal.action === 'store'">
          <CInput
            label="Cantidad inicial"
            placeholder="Ej: 3"
            v-model="material.quantity"
            type="number"
            min="1"
            @input="validateInteger('quantity')"
          />
          <small class="text-muted">Nro. de unidades que ingresan al stock</small>
        </CCol>

        <CCol sm="6">
          <CInput
            label="Precio por Unidad"
            placeholder="Digite precio"
            v-model="material.price_total"
            type="number"
            @input="validateDecimal('price_total')"
          />
        </CCol>

        <CCol v-if="modal.action !== 'store'" sm="12">
          <label>Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="material.state == 1"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- ===================== MODAL DELETE ===================== -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Material'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index",              label: "#",               _style: "width:3%;"  },
  { key: "name",               label: "Nombre",          _style: "width:30%;" },
  { key: "unit_name",          label: "Unidad",          _style: "width:12%;" },
  { key: "stock_total",        label: "Stock",           _style: "width:15%;" },
  { key: "price_total",        label: "Precio x Unidad", _style: "width:12%;" },
  { key: "precio_total_stock", label: "Precio Total",    _style: "width:13%;" },
  { key: "status",             label: "Estado",          _style: "width:8%;"  },
];

import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import CModalForm    from "../../../components/shared/modals/cModalForm.vue";
import cModalDelete  from "../../shared/modals/cModalDelete.vue";
import CSwitchVue    from "../../shared/switch/CSwitch.vue";
import cSelectForm   from "../../../components/shared/inputs/cSelect.vue";
import { mapActions } from "vuex";

export default {
  components: { CTableWrapper, CModalForm, cModalDelete, CSwitchVue, cSelectForm },

  data() {
    return {
      prefix: "material",
      fields,
      data: [],
      data_units: [],

      import_excel: {
        file:    null,
        loading: false,
      },

      modal: {
        action:     "",
        title:      "",
        modal_form: false,
      },

      material: {
        id:         "",
        company_id: this.$store.getters.get_company.id,
        campu_id:   this.$store.getters.get_campu.id,
        unit_id:    "",
        name:       "",
        quantity:   1,
        price_total:"",
        state:      1,
      },

      modal_delete: {
        boo:  false,
        item: [],
      },

      labelIcon: {
        labelOn:  "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
    };
  },

  computed: {
    cp_button() {
      return !(this.material.name && this.material.unit_id);
    },
  },

  created() {
    this.mtd_getdata();
    this.mtd_getUnits();
  },

  methods: {
    ...mapActions(["get", "post"]),

    // ------------------------------------------------------------------
    // CARGA DE DATOS
    // ------------------------------------------------------------------

    mtd_getdata() {
      const company_id = this.$store.getters.get_company.id;
      const campu_id   = this.$store.getters.get_campu.id;

      this.get({
        url:   `${this.$store.getters.get__url}/${this.prefix}/index/${company_id}/${campu_id}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data.data.map((item, i) => {
            const s            = item.stock || {};
            const subUnitName  = item.sub_unit_name || item.unit_name;

            // Mostrar el total de sub-unidades base (resultado de multiplicar la jerarquía)
            // Ejemplo: 1 CAJAX12 con quantity_remaining=72 → "72 UNIDAD"
            const stock_total = `${s.total_sub_units || 0} ${subUnitName}`;

            const precio_total_stock = (
              parseFloat(s.total_units || 0) * parseFloat(item.price_total || 0)
            ).toFixed(2);

            return {
              ...item,
              index:              i + 1,
              stock_total,
              precio_total_stock,
            };
          });
        })
        .catch((errors) => console.log(errors));
    },

    mtd_getUnits() {
      const company_id = this.$store.getters.get_company.id;

      this.get({
        url:   `${this.$store.getters.get__url}/material/byUnit/${company_id}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data_units = response.data.data.map((u) => ({
            label: u.name,
            value: u.id,
          }));
        })
        .catch((errors) => console.log(errors));
    },

    // ------------------------------------------------------------------
    // NAVEGACIÓN
    // ------------------------------------------------------------------

    mtdBack() {
      this.$emit("mtdBack");
    },

    // ------------------------------------------------------------------
    // MODAL STORE / UPDATE
    // ------------------------------------------------------------------

    mtd_open_modal(boo, action) {
      this.modal.modal_form = boo;
      this.modal.action     = action;
      this.modal.title      = action === "store" ? "Nuevo Material" : "Editar Material";

      if (action === "store") {
        this.material = {
          id:          "",
          company_id:  this.$store.getters.get_company.id,
          campu_id:    this.$store.getters.get_campu.id,
          unit_id:     "",
          name:        "",
          quantity:    1,
          price_total: "",
          state:       1,
        };
      }
      if (action !== "store") {
        this.componentKey += 1;
      }
    },

    mtd_action() {
      // Al crear usamos el endpoint simple (ítems nacen opened)
      // Al editar sigue usando el update normal (no toca el stock)
      const endpoint = this.modal.action === "store" ? "store-simple" : this.modal.action;

      this.post({
        url:    `${this.$store.getters.get__url}/${this.prefix}/${endpoint}`,
        token:  this.$store.getters.get__token,
        params: this.material,
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({ title: "Material ya registrado con esa unidad", icon: "warning" });
            return;
          }
          const message = this.modal.action === "store"
            ? "REGISTRADO CORRECTAMENTE"
            : "EDITADO CORRECTAMENTE";

          this.modal = { action: "", title: "", modal_form: false };
          this.mtd_getdata();
          Swal.fire({ title: message, icon: "success" });
        })
        .catch(() => Swal.fire({ title: "Error en la operación", icon: "error" }));
    },

    mtd_show(id) {
      this.get({
        url:   `${this.$store.getters.get__url}/${this.prefix}/show/${id}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.material = {
            id:          response.data.Id,
            company_id:  response.data.company_id,
            campu_id:    response.data.campu_id,
            unit_id:     response.data.unit_id,
            name:        response.data.name,
            price_total: response.data.price_total,
            state:       response.data.state,
          };
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => console.log(errors));
    },

    // ------------------------------------------------------------------
    // DELETE
    // ------------------------------------------------------------------

    mtd_delete(item) {
      this.modal_delete.boo  = true;
      this.modal_delete.item = item;
    },

    mtd_commit() {
      this.post({
        url:    `${this.$store.getters.get__url}/${this.prefix}/destroy`,
        token:  this.$store.getters.get__token,
        params: { id: this.modal_delete.item.Id },
      })
        .then((response) => {
          if (response.data.state == 2) {
            this.modal_delete = { boo: false, item: [] };
            Swal.fire({
              title: "No se puede eliminar",
              text:  "Este material está siendo usado en uno o más tratamientos activos.",
              icon:  "warning",
            });
            return;
          }
          this.mtd_getdata();
          this.modal_delete = { boo: false, item: [] };
          Swal.fire({ title: "ELIMINADO CORRECTAMENTE", icon: "success" });
        })
        .catch(() => Swal.fire({ title: "Error en la operación", icon: "error" }));
    },

    // ------------------------------------------------------------------
    // HELPERS
    // ------------------------------------------------------------------

    changeSwitch(payload) {
      this.material.state = payload ? 1 : 0;
    },

    validateDecimal(field) {
      let val   = String(this.material[field]);
      val       = val.replace(/[^\d.]/g, "");
      const parts = val.split(".");
      if (parts[1] && parts[1].length > 2) parts[1] = parts[1].substring(0, 2);
      if (parts.length > 2) val = `${parts[0]}.${parts[1]}`;
      else val = parts.join(".");
      if (parseFloat(val) < 0) val = "0";
      this.material[field] = val;
    },

    validateInteger(field) {
      let val = String(this.material[field]);
      val     = val.replace(/[^\d]/g, "");
      if (parseInt(val) < 1 || val === "") val = "1";
      this.material[field] = val;
    },

    // ------------------------------------------------------------------
    // IMPORTAR EXCEL (sin cambios)
    // ------------------------------------------------------------------

    mtd_onFileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.$refs.inputExcel.value = "";

      Swal.fire({
        title:             "¿Importar este archivo?",
        text:              file.name,
        icon:              "question",
        showCancelButton:  true,
        confirmButtonText: "Sí, importar",
        cancelButtonText:  "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.mtd_importExcel(file);
        }
      });
    },

    mtd_importExcel(file) {
      this.import_excel.loading = true;

      const formData = new FormData();
      formData.append("archivo", file);

      const token = this.$store.getters.get__token;
      const url   = `${this.$store.getters.get__url}/import/excel`;

      fetch(url, {
        method:  "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept:        "application/json",
        },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          this.import_excel.loading = false;

          if (data.state == 1) {
            this.mtd_getdata();
            let msg = `Se importaron ${data.importados} materiales correctamente.`;
            if (data.errores && data.errores.length) {
              msg += `\n\nFilas con errores:\n${data.errores.join("\n")}`;
            }
            Swal.fire({ title: "Importación completada", text: msg, icon: "success" });
          } else {
            const errMsg = data.errores ? data.errores.join("\n") : data.message;
            Swal.fire({ title: "Error en la importación", text: errMsg, icon: "error" });
          }
        })
        .catch(() => {
          this.import_excel.loading = false;
          Swal.fire({ title: "Error de conexión", icon: "error" });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>